// client/src/components/clientPortal/PwaSupport.js — the client portal inside the BREC app.
//
// The whole site is now one installable app with ONE service worker (/sw.js, scope "/",
// registered from index.js by client/src/pwa/registerServiceWorker.js; static files
// only, never API data or anything personal). The client portal keeps its OWN manifest
// (/client-portal/manifest.webmanifest, scope /client-portal/, start /client-portal/dashboard)
// so a client who installs from the portal lands on their dashboard, not on the staff
// login. While a portal page is open, the page's manifest link points at it; leaving
// the portal puts the site manifest back.
import React, { useEffect } from 'react';
import { InstallAppBanner } from '../shared/InstallApp';

const PORTAL_MANIFEST = '/client-portal/manifest.webmanifest';

/** Point the manifest link at the client portal's while a portal page is mounted. */
export const usePortalPwa = () => {
    useEffect(() => {
        let link = document.head.querySelector('link[rel="manifest"]');
        let created = false;
        if (!link) {
            link = Object.assign(document.createElement('link'), { rel: 'manifest' });
            document.head.appendChild(link);
            created = true;
        }
        const previous = link.getAttribute('href');
        link.setAttribute('href', PORTAL_MANIFEST);
        return () => {
            if (created) link.remove();
            else if (previous) link.setAttribute('href', previous);
        };
    }, []);
};

/** "Install the app" — the browser's prompt where it offers one, instructions on iPhone/iPad. */
export const InstallPrompt = () => <InstallAppBanner />;
